import {
  Home as HomeIcon,
  Hotel as HotelIcon,
  Settings as SettingsIcon,
  MenuBook as MenuBookIcon,
} from '@mui/icons-material';
import { PERMISSIONS, getPermissionDeniedMessage } from '../auth/permissions';

/** Bottom nav tabs for onboarding landing (matches dashboard shell layout). */
export function getLandingBottomTabs(selectedMenu, onSelectView, options = {}) {
  const canViewOrgDashboard = options.canViewOrgDashboard !== false;
  const deniedTooltip = options.deniedTooltip
    || getPermissionDeniedMessage(PERMISSIONS.DASHBOARD_VIEW, 'Organisation Dashboard');

  const tab = (id, label, icon, viewKey, extra = {}) => ({
    id,
    label,
    icon,
    isActive: selectedMenu === viewKey,
    disabled: Boolean(extra.disabled),
    disabledTooltip: extra.disabledTooltip,
    onClick: () => {
      if (extra.disabled) return;
      onSelectView(viewKey);
    },
  });

  return {
    leftTabs: [
      tab('dashboard', 'Dashboard', HomeIcon, 'dashboard', {
        disabled: !canViewOrgDashboard,
        disabledTooltip: deniedTooltip,
      }),
      tab('hotels', 'Hotelier', HotelIcon, 'hotels'),
    ],
    rightTabs: [
      tab('settings', 'Settings', SettingsIcon, 'settings'),
      tab('user-guide', 'Guide', MenuBookIcon, 'user-guide'),
    ],
  };
}

export default getLandingBottomTabs;
